import { Controller } from 'stimulus';
import axios from 'axios';

/*
 * form内のnested attributeで動的な要素の追加を行う。
 */
export default class extends Controller {
  static targets = ['container', 'addButton'];

  connect() {
    this.count = parseInt(this.data.get('count'), 10);
    if (Number.isNaN(this.count)) throw new Error('初期カウント値未設定');
    this.max = parseInt(this.data.get('max'), 10);
  }

  add() {
    if (this.max && this.count >= this.max) {
      alert('これ以上追加できません。');
      return;
    }

    axios.get(this.data.get('url')).then(res => {
      const newElement = document.createElement('div');
      newElement.innerHTML = res.data;
      this.containerTarget.appendChild(newElement);
    });

    this.count += 1;
  }

  decrementCount() {
    this.count -= 1;
  }
}
